module.exports = __webpack_public_path__ + "static/media/mayfield.c8da6a91.png";